import request from './request'

// 通用请求方法
export function http_post(url, data, loading = false) {
  return request({
    url: url,
    method: 'post',
    data,
    loading: loading
  })
}

export function http_get(url, loading = false) {
  return request({
    url: url,
    method: 'get',
    loading: loading
  })
}
